import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import {IEcommerceData} from '../../IGoogleTagManager';
import ECommerceEventModel from './EcommerceEventModel';
import ECommerceProductDetailsModel from './models/EcommerceProductDetailsModel';

/**
 * Represents ECommerceProductDetailViewEventModel
 */
export default class ECommerceProductDetailViewEventModel extends ECommerceEventModel {
	public ecommerce: IEcommerceData;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.ecommerce = {
			detail: {
				actionField: {
					list: this.getSource()
				},
				products: [{...new ECommerceProductDetailsModel(managerRepository, data.productData)}]
			}
		};
	}
};
